/*
*   程序主入口
*/
require('../../js/array.from');
require('../../js/array.find');
import perf from './Performance.js';
import Report from './Report.js';
import ErrorPlugin from './ErrorPlugin';
import util from './Util';
import Fingerprint2 from 'fingerprintjs2'; // 引入fingerprintjs2
let documentErrorObj = {}
let cssChangedTime = 0;
// 获取首屏时间的超时时间限制，单位毫秒
const FIRST_SCREEN_TIMEOUT = 4000;
export default class Monitor {
    constructor(options = {}) {
        // { ssr: <Boolean>, timeout: <Number:ms> }
        this.options = options;

        this.perfData = {};
        this.jsErrorData = {};
        this.vueErrorData = {};
        this.docErrorData = {};
        this.errorRes = [];
        this.inApp = window.PPDWebUI && window.PPDWebUI.os && window.PPDWebUI.os.inApp || false;

        // 以外链方式引入时，获取通过data-params属性传入的参数
        this.dataParams = util.getParamsFormScript('monitorJs', 'data-params') || {};

        if (window && window.__USE_SSR__ === true) {
            this.options.ssr = true;
        } else {
            this.options.ssr = false;
        }

        if (this.dataParams.isClosed !== 'true') {
            this.handlePVandUV();
            this.handleDocError();
            this.handleJsError();
            this.handlePerf();
            this.handleWhiteScreenError();
            !this.inApp && !localStorage.getItem('xinyeBrowserId') && this.handleFingerprint();
        }
    }

    handleWhiteScreenError() {
        window.addEventListener('load', () => {
            let errorCoreScript = []
            if (this.errorRes.length) {
                let scripts = document.getElementsByTagName('script')
                if (scripts.length) {
                    Array.from(scripts).forEach(item => {
                        if (item.getAttribute('corejs') === '1' && this.errorRes.indexOf(item.src) > -1) {
                            errorCoreScript.push(item.src)
                        }
                    })
                }
            }
            if (errorCoreScript.length) {
                util.showErrorPage()
                let data = {
                    eventId: util.uuid(),
                    eventType: 'h5_whitescreen_error',
                    errorMessage: errorCoreScript,
                };
                let report = new Report(data);
                report.sendByH5();
            }
        })
    }

    handleDocError() {
        // 子资源异常上报
        window.addEventListener && window.addEventListener('error', (error) => {
            if (error.target && error.target.src && error.target.getAttribute('src')) {
                let key = window.location.href
                let value = error.target.src
                if (!documentErrorObj[key]) { //没有存储过对应页面
                    documentErrorObj[key] = [value]
                    this.errorRes.push(value)
                    this.errorHanding(error);
                } else if (documentErrorObj[key].indexOf(value) < 0) { //没有存储过src
                    documentErrorObj[key].push(value)
                    this.errorRes.push(value)
                    this.errorHanding(error);
                }
            }
        }, true);
    }

    errorHanding(error) {
        // console.log('子资源异常上报', error.target, error.target.src);
        // 如果一个元素的src没有赋值, error.target.src 返回的是相对路径-当前页的地址, e.target.getAttribute('src')返回的是空字符串
        let _error = new ErrorPlugin({
            path: error.target.getAttribute('src')
        });
        let data = _error.handleResouceError();
        // console.log('errorHanding this:', this);
        this.docErrorData = data;
        let report = new Report(data);
        // report.sendRequest();
        report.sendByH5();
        error.target.getAttribute('src') && util.findMissedResource(error.target.src);
    }

    handleJsError() {
        // JS 错误上报
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            // console.log('捕获到了js错误', error.stack.toString());
            let errorJs = new ErrorPlugin();
            let data = errorJs.handleJsError(msg, url, lineNo, columnNo, error);
            this.jsErrorData = data;
            let report = new Report(data);
            report.sendByH5();
        };

        // Vue会拦截错误，所以使用Vue的方法获取错误栈信息
        if (window.Vue) {
            window.Vue.config.errorHandler = (err, vm, info) => {
                // console.log('捕获到了 vue error 错误');
                let errorVue = new ErrorPlugin();
                let data = errorVue.handleVueError(err, vm, info);
                this.vueErrorData = data;
                // console.log('err:', err, err.message,err.name, err.fileName, JSON.stringify(err));
                let reportVue = new Report(data);
                reportVue.sendByH5();
            };
        }

        // 处理promise 报错
        window.addEventListener("unhandledrejection", err => {
            // console.log(err.reason, err);
            err.preventDefault();
            if (err.reason && err.reason.config && err.reason.config.url && err.reason.config.url.indexOf('webuimonitor') > -1) return;
            let errorPromise = new ErrorPlugin();
            let data = errorPromise.handleJsError(err.reason.message, '', '', '', err);
            this.promiseErrorData = data;
            let reportPromise = new Report(data);
            reportPromise.sendByH5();
        }, false);
    }

    handlePerf() {
        /***    获取首屏时间
        ****    设置性能数据
        ****    上报结果
        *****/
        let _this = this;
        (function () {
            // 手机屏幕高度
            let firstScreenHeight = screen.height;
            // 首屏内的所有图片数组
            let firstScreenImgs = [];
            // 标记是否找到了首屏的最后一张图片
            let isFindLastImg = false;
            // 标记首屏内的所有图片是否加载完成
            let allImgLoaded = false;
            let fst = 0;
            let fmp = 0;
            let totalRequestResource = 0;
            let timing = perf.getPerformance();
            let timer;
            let onloadTimer;

            function reportPerfData() {
                // 上报所有性能数据
                let data = perf.setData();
                data.baseTime.FMP_DOM = fst;
                fmp = perf.getFMPTime();
                data.baseTime.FMP_API = fmp;
                data.baseTime.FMP = fmp > fst ? fmp : fst;
                
                data.totalRequestResource = totalRequestResource + perf.findFontCount();
                data.baseTime.csr_skin = cssChangedTime;
                _this.perfData = data;
                util.filterInvalidProps(data.baseTime, ['FMP', 'FMP_API', 'FMP_DOM']);
                let report = new Report(data);
                report.sendRequest();
            }
            
            window.addEventListener('load', () => {
                // 获取所有的资源数
                totalRequestResource = perf.getResourceStatic();
            });

            perf.getFirstScreenTime(_this.options.timeout || _this.dataParams.firstScreenTimeout || FIRST_SCREEN_TIMEOUT).then(obj => {
                fst = obj.firstScreenTime;
                reportPerfData();
            });
        })();
    }

    // 全局函数 window.PPDMonitor.didMounted，给vue的mounted之后调用
    didMounted() {
        mountedTime = perf.getCurrentToStart()
    }

    // 全局函数 window.PPDMonitor.FinishCssChange，给css换肤完成之后调用
    FinishCssChange() {
        cssChangedTime = perf.getCurrentToStart();
    }

    // 生成设备指纹
    handleFingerprint() {
        return new Promise(resolve => {
            if (localStorage.getItem('xinyeBrowserId')) {
                const browserId = localStorage.getItem('xinyeBrowserId');
                resolve(browserId);
            } else {
                if (window.requestIdleCallback) {
                    requestIdleCallback(() => {
                        this.createFingerprint(resolve);
                    });
                } else {
                    setTimeout(() => {
                        this.createFingerprint(resolve);
                    }, 500);
                }
            }
        });
    }

    createFingerprint(resolve) {
        if (localStorage.getItem('xinyeBrowserId')) {
            const browserId = localStorage.getItem('xinyeBrowserId');
            resolve(browserId);
        } else {
            // 选择哪些信息作为浏览器指纹生成的依据
            const options = {
                excludes: {
                    enumerateDevices: true,
                },
            };
            // 浏览器指纹
            const fingerprint = Fingerprint2.get(options, (components) => {
                const values = components.map(component => component.value); // 配置的值的数组
                const murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
                localStorage.setItem('xinyeBrowserId', murmur); // 存储浏览器指纹
                resolve(murmur);
            });
        }
    }

    registerParams(params) {
        Report.prototype.extendParams = params;
    }

    sendReport(obj) {
        let report = new Report(obj);
        report.sendByH5();
    }

    handlePVandUV() {
        var data = {
            eventId: util.uuid(),
            eventType: 'h5_pv_uv',
            timestamp: util.setTimestamp(new Date()),
        }
        let report = new Report(data);
        report.sendByH5();
    }
}

